import React from 'react';

import style from './style.module.css';

const Title = (props) => {
    const { tag = "h1", className = "", children, dangerouslySetInnerHTML, transform = "", align = "left" } = props;
    const Tag = tag;

    if (!tag) return null;

    return (
        <div className={style.title}>
            {dangerouslySetInnerHTML ? (
                <Tag 
                    className={`${style[tag]}${className !== "" ? ` ${style[className]}` : ""}${transform !== "" ? ` ${style[transform]}` : ""}${align !== "" ? ` ${style[align]}` : ""}`} 
                    dangerouslySetInnerHTML={dangerouslySetInnerHTML}
                />
            ) : (
                <Tag className={`${style[tag]}${className !== "" ? ` ${style[className]}` : ""}${transform !== "" ? ` ${style[transform]}` : ""}${align !== "" ? ` ${style[align]}` : ""}`}>
                    {children}
                </Tag>
            )}
        </div>
    );
};

export default Title;
